export const clone = (obj: any): any => {
  const objToString = JSON.stringify(obj);
  return JSON.parse(objToString);
};
